import type { StatusMap } from '~/types';

export const accountStatusMap: StatusMap = {
  CREATED: {
    icon: 'Clock',
    theme: 'warning'
  },
  ACCEPTED: {
    icon: 'Check',
    theme: 'success'
  },
  DENIED: {
    icon: 'Block',
    theme: 'danger'
  },
  BLOCKED: {
    icon: 'Close',
    theme: 'danger'
  }
};
